export const specialPriceActive = state => state.specialPriceActive // 获取所有的活动对象
export const selectedStoreList = state => state.selectedStoreList // 获取所有已经选择的门店数据
export const GET_EDITOR_CONTENT = state => state.editorContent // 获取富文本详情
